<template>
    <div>
        <div class="container space">
            <div class="row ">
                <div class="col col-lg-12 col-sm-12">
                    <div class="section-title-s3">
                        <span>Our Team</span>
                        <h2>Get to know our team</h2>
                    </div>
                </div>
            </div>
        </div>
        <section>
            <div class="container space">
                <div class="row ">
                    <div class="col-md-12">
                        <p>
                            Streamline Solutions is the Puget Sound’s leader in commercial,
                            low voltage installations. We offer a full range of services in order to guarantee the success of your AV project and the viability
                            of your system. Our services include consultation, system design, engineering, installation, and on-going maintenance.
                            We provide superior low voltage solutions for data, audio, and video.
                        </p>
                    </div>
                </div>
            </div>
        </section>
        <section>
            <div class="container space space-below team">

                <cb-structured section="team-list" :schema="teamSchema" >
                    <template v-slot:content="slotProps">
                        <div class="row no-gutters">
                            <div class="col-md-4 col-xs-12 "  v-for="(member, i) in slotProps.content.teamMembers.items" :key='i'>
                                <div class="card">
                                    <div class="img-holder">
                                        <img v-if="member.pic.url" class="card-img-top" :src="member.pic.url" :alt="member.name.text"/>
                                        <img v-else class="card-img-top" src="/assets/images/team/unnamed.jpg" :alt="member.name"/>
                                    </div>
                                    <div class="card-body">
                                        <div class="card-title">{{member.name.text}}</div>
                                        <div class="card-text">{{member.position.text}}</div>
                                        <div v-if="member.fact" class="facts mt-2">
                                            <div v-if="member.fact.text && member.fact.text.length > 0" class="" ><strong>Interesting fact:</strong> {{member.fact.text}}</div>
                                        </div>
                                    </div>
                                </div>

                            </div>
                        </div>
                    </template>
                </cb-structured>
            </div>
        </section>

    </div>

</template>

<script>
import team from './teamUser.js'
export default {
    name: 'team',
    data() {
        return {
            team,
            teamSchema: {
                fields: [
                    {
                        id: 'teamMembers',
                        label: 'Team Members',
                        type: 'list',
                        fields: [
                            {
                                id: 'name',
                                label: 'Name',
                                type: 'text'
                            },
                            {
                                id: 'position',
                                label: 'Position',
                                type: 'text'
                            },
                            {
                                id: 'fact',
                                label: 'Interesting Fact',
                                type: 'text-area'
                            },
                            {
                                id: 'pic',
                                label: 'Image',
                                type: 'image'
                            }
                        ]
                    }
                ]
            }
        }
    }
}
</script>

<style lang="scss" scoped>

    .team {
        .row {
            display: -webkit-box;
            display: -webkit-flex;
            display: -ms-flexbox;
            display:         flex;
            flex-wrap: wrap;
        }
        .row > [class*='col-'] {
            display: flex;
            flex-direction: column;

        }
        .no-gutters {
            margin-left: -8px;
        }
    }



    img {
        width: 100%;
        height: 250px;
        object-fit: cover;
    }
    .card {
        margin: 8px;
        padding: 0px;
        height: 100%;


        border-radius: 5px !important;
        -webkit-box-shadow: 0px 7px 86px -21px rgba(204,204,204,1);
        -moz-box-shadow: 0px 7px 86px -21px rgba(204,204,204,1);
        box-shadow: 0px 7px 86px -21px rgba(204,204,204,1);
    }
    .card-body {
        padding: 10px 15px;
        width: 100%;
    }
    .card-text {
        //font-size: 80%;
        font-weight: 600;
    }

    .facts div {
        //font-size: 85%;
    }


    @media (max-width: 960px) {
      .box {
        display: flex;
        flex-direction: column;
        justify-items: center;
        align-items: center;
      }
    }
</style>
